import { makeStyles } from "@material-ui/core/styles";
import { blue900 } from "../../../../components/common/PL/constants";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 6,
  },
  name: {
    fontFamily: "'Nunito Sans', 'Avenir Next', 'Segoe UI', sans-serif",
    fontSize: "1.75rem",
    fontWeight: 800,
    color: blue900,
    lineHeight: 1.36,
    letterSpacing: "-0.015em",
  },
  description: {
    fontSize: "1rem",
    fontWeight: 400,
    color: "#5B5D66",
    lineHeight: 1.4,
  },
}));

export default useStyles;
